export const FacebookIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/facebook-bmc.svg"
      alt={alt}
    />
  );
};

export const MessengerIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/facebook-messenger-bmc.svg"
      alt={alt}
    />
  );
};

export const InstagramIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/instagram-bmc.svg"
      alt={alt}
    />
  );
};

export const LinkedInIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/linkedin-bmc.svg"
      alt={alt}
    />
  );
};

export const PinterestIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/pinterest-bmc.svg"
      alt={alt}
    />
  );
};

export const SnapchatIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/snapchat-bmc.svg"
      alt={alt}
    />
  );
};

export const TiktokIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/tiktok-bmc.svg"
      alt={alt}
    />
  );
};

export const TwitchIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/twitch-bmc.svg"
      alt={alt}
    />
  );
};

export const TwitterIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/twitter-bmc.svg"
      alt={alt}
    />
  );
};

export const WhatsappIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/whatsapp-bmc.svg"
      alt={alt}
    />
  );
};

export const YoutubeIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/youtube-bmc.svg"
      alt={alt}
    />
  );
};

export const DiscordIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/discord-bmc.svg"
      alt={alt}
    />
  );
};

export const BehanceIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/behance-bmc.svg"
      alt={alt}
    />
  );
};

export const DribbleIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/dribbble-bmc.svg"
      alt={alt}
    />
  );
};

export const GeneralLinkIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/general-link-bmc.svg"
      alt={alt}
    />
  );
};

export const LineChatIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <img
      className={className}
      width={width}
      height={height}
      src="https://image.passio.eco/page-builder/page-builder/social-icons/line-chat.svg"
      alt={alt}
    />
  );
};

export const TelIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="4"
        fill="#37C837"
      />
      <path
        d="M5 5.9375C5 5.41973 5.41973 5 5.9375 5H7.95582C8.41411 5 8.80522 5.33132 8.88056 5.78338L9.57367 9.94201C9.64133 10.348 9.4363 10.7506 9.06819 10.9347L7.61681 11.6603C8.66334 14.2609 10.7391 16.3367 13.3397 17.3832L14.0653 15.9318C14.2494 15.5637 14.652 15.3587 15.058 15.4263L19.2166 16.1194C19.6687 16.1948 20 16.5859 20 17.0442V19.0625C20 19.5803 19.5803 20 19.0625 20H17.1875C10.4565 20 5 14.5435 5 7.8125V5.9375Z"
        fill="white"
      />
    </svg>
  );
};

export const EmailIcon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="4"
        fill="white"
      />
      <rect
        width="24"
        height="24"
        rx="4"
        fill="#E84636"
      />
      <path
        d="M4.00333 7.88355L11.9999 11.8819L19.9967 7.8835C19.9363 6.83315 19.0655 6 18 6H6C4.93452 6 4.06363 6.83318 4.00333 7.88355Z"
        fill="white"
      />
      <path
        d="M20 10.1179L11.9999 14.1179L4 10.118V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V10.1179Z"
        fill="white"
      />
    </svg>
  );
};

export const Lemon8Icon = ({
  alt = "",
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24" 
      fill="none" xmlns="http://www.w3.org/2000/svg"
      >
      <rect width={width} height={height} rx="4" fill="#FFF700" />
      <path d="M19.9785 8.21998C19.3925 8.38404 19.0785 8.7731 19.0785 9.3356C19.0785 9.63092 19.1628 9.83717 19.3878 10.0762C19.4722 10.17 19.5097 10.2403 19.4769 10.2544C19.3129 10.3153 18.9894 10.5731 18.8769 10.7325C18.6941 10.9997 18.666 11.3887 18.816 11.6747C19.0269 12.0872 19.5332 12.3028 20.2832 12.3028C20.9488 12.2981 21.4644 12.0637 21.7035 11.6512C21.7925 11.4919 21.8066 11.4075 21.7972 11.1262C21.7832 10.8309 21.7644 10.77 21.6378 10.6106C21.5582 10.5122 21.4269 10.3856 21.3425 10.3294L21.1925 10.2309L21.4644 10.0387C21.8066 9.79498 21.9566 9.56998 21.9847 9.25123C22.0128 8.9231 21.9754 8.80123 21.7832 8.5856C21.53 8.30435 21.216 8.19185 20.6582 8.1731C20.3769 8.16373 20.105 8.18248 19.9785 8.21998ZM20.9629 8.90904C21.0097 8.93248 21.0707 9.02154 21.1035 9.10123C21.1597 9.23248 21.155 9.26998 21.0753 9.41998C20.9535 9.64967 20.5222 9.91217 20.3816 9.83717C20.2316 9.76217 20.0722 9.60279 19.9925 9.45748C19.8238 9.12467 20.1894 8.78248 20.6535 8.83873C20.78 8.85279 20.9207 8.8856 20.9629 8.90904ZM20.7847 10.9387C21.0144 11.1731 20.93 11.4778 20.6066 11.5809C20.3722 11.6606 19.9035 11.6137 19.7488 11.4965C19.6597 11.4309 19.6222 11.3559 19.6129 11.2106C19.5941 10.9669 19.716 10.784 19.9879 10.6481L20.1847 10.5544L20.4191 10.6809C20.5457 10.7512 20.7097 10.8684 20.7847 10.9387Z" fill="black" />
      <path d="M16.191 8.93248C16.0128 9.00748 15.9519 9.13873 15.8254 9.6731C15.7457 10.0247 15.7363 10.034 15.5769 10.0762C15.1269 10.1887 15.1644 10.2028 15.0847 9.92154C14.9113 9.33092 14.4566 8.95123 13.9222 8.95123C12.9847 8.95123 12.3847 9.61685 12.3566 10.6903L12.3472 11.1356L12.1504 11.3606C11.991 11.5387 11.9254 11.5809 11.8269 11.5715C11.6019 11.5434 11.5738 11.3934 11.6347 10.5262C11.7004 9.64029 11.6769 9.36842 11.5175 9.20904C11.2363 8.92779 10.6269 9.21842 10.2379 9.8231C10.1722 9.92623 10.0457 10.1887 9.96129 10.409L9.81129 10.8075L9.82066 10.2215C9.83004 9.53717 9.78316 9.40592 9.50191 9.34967C9.28629 9.31217 8.87847 9.50435 8.68629 9.73873C8.4941 9.9731 8.26441 10.4137 8.13316 10.8075L8.02066 11.1356L8.05347 10.5497C8.07223 10.2262 8.08629 9.87935 8.09098 9.77623L8.09566 9.58873L7.88473 9.57467C7.72066 9.56529 7.6316 9.58873 7.50973 9.66842C7.27535 9.82779 7.2191 10.0762 7.21441 10.995L7.20504 11.7403L6.93785 12.0262C6.48785 12.5137 5.97691 12.7106 5.61597 12.5419C5.52222 12.4997 5.44722 12.4434 5.44722 12.4247C5.44722 12.4012 5.55972 12.3262 5.69097 12.2465C6.06597 12.0356 6.38473 11.7309 6.5066 11.4637C6.79722 10.8403 6.5066 10.095 5.93472 10.0059C5.47535 9.94029 4.90816 10.1934 4.63629 10.5872C4.34566 10.9997 4.27535 11.3887 4.33629 12.209C4.34566 12.3309 4.30816 12.3684 3.81129 12.6637C3.52066 12.8419 3.24879 12.9872 3.21129 12.9872C3.04722 12.9872 3.05191 12.7622 3.22066 11.8106C3.55816 9.93092 3.55347 9.66373 3.1691 9.2981C2.84566 8.98873 2.47535 8.98404 2.17066 9.28404C1.96441 9.49029 1.95972 9.60279 2.1191 10.2356C2.29254 10.9059 2.35347 11.5294 2.35347 12.6965C2.35347 13.6106 2.3816 13.7465 2.59722 13.8965C2.73316 13.995 3.15972 13.995 3.34722 13.8965C3.42691 13.8544 3.7316 13.5919 4.02691 13.3106C4.32222 13.0294 4.58472 12.7997 4.60816 12.7997C4.6316 12.7997 4.71597 12.87 4.79097 12.959C5.28785 13.5215 6.44097 13.4325 7.17691 12.7715L7.41129 12.5606L7.49097 12.7012C7.53785 12.7809 7.6316 12.8653 7.7066 12.8887C7.87066 12.945 8.14722 12.8747 8.21285 12.7528C8.23629 12.7059 8.29254 12.4387 8.33004 12.1575C8.46598 11.1872 8.78941 10.3575 8.96754 10.5356C8.99097 10.559 9.02379 10.9059 9.03785 11.3044C9.06597 12.0825 9.13629 12.3965 9.30504 12.5512C9.45504 12.6872 9.5441 12.7059 9.73629 12.6544C9.94723 12.5934 10.0082 12.4669 10.0832 11.8856C10.1816 11.1637 10.5332 10.2684 10.716 10.2684C10.7722 10.2684 10.7863 10.4231 10.8004 11.0981C10.8144 12.0403 10.8613 12.1856 11.166 12.345C11.4941 12.5137 12.0941 12.3544 12.4597 11.9981L12.6472 11.8106L12.741 11.9137C13.055 12.2606 13.7347 12.3919 14.1988 12.1903C14.5269 12.0497 14.8738 11.6794 15.0003 11.3325C15.0566 11.1825 15.1035 11.0325 15.1035 10.9903C15.1035 10.9106 15.141 10.8965 15.4363 10.8544L15.6519 10.8262L15.68 11.2622C15.7316 12.0075 15.8253 12.1903 16.1675 12.1903C16.4488 12.1903 16.5191 12.1012 16.6972 11.5294C16.8707 10.9575 17.1472 10.3622 17.3535 10.1137C17.6254 9.79029 17.6535 9.88404 17.541 10.7184C17.4894 11.0794 17.4472 11.5106 17.4472 11.6794C17.4472 11.9419 17.4613 12.0028 17.555 12.0872C17.7003 12.2231 18.0425 12.2278 18.2066 12.0965C18.3191 12.0122 18.3285 11.97 18.3566 11.4309C18.3753 11.1122 18.4316 10.5731 18.4832 10.2309C18.591 9.47623 18.5957 9.15279 18.5019 9.01685C18.3941 8.86685 18.141 8.83404 17.8269 8.93248C17.4566 9.04967 17.03 9.49029 16.7441 10.0481C16.6316 10.2731 16.5332 10.4559 16.5238 10.4559C16.505 10.4559 16.5566 10.1887 16.6785 9.66842C16.8097 9.09654 16.8191 8.92779 16.716 8.89029C16.5941 8.84342 16.355 8.86217 16.191 8.93248ZM13.8707 9.94029C13.8847 10.2215 14.0628 10.5919 14.2457 10.7278C14.3675 10.8169 14.3722 10.8262 14.3113 11.0231C14.2222 11.309 13.9879 11.534 13.7675 11.534C13.5519 11.534 13.355 11.3512 13.28 11.084C13.2144 10.8544 13.2144 10.4372 13.2754 10.2122C13.341 9.98717 13.6035 9.70592 13.7488 9.70592C13.8519 9.70592 13.8613 9.72935 13.8707 9.94029ZM5.76597 10.77C5.85972 10.8497 5.89254 10.9669 5.87847 11.1965C5.86441 11.3887 5.2691 11.9372 5.17535 11.8434C5.16129 11.8247 5.14722 11.684 5.14722 11.52C5.14254 11.1731 5.26441 10.859 5.44254 10.7606C5.60191 10.6715 5.65347 10.6762 5.76597 10.77Z" fill="black" />
      <path d="M14.7519 13.77C11.9207 13.9012 9.21597 14.2434 6.83004 14.7731C5.78004 15.0028 5.55504 15.0778 5.46597 15.2137C5.40035 15.3122 5.40035 15.3403 5.46597 15.4622C5.50816 15.5465 5.62535 15.645 5.74722 15.7012C6.11285 15.8794 6.32379 15.8747 7.22847 15.6684C8.98629 15.2606 11.0722 14.9325 13.1113 14.7497C14.2972 14.6419 14.9629 14.6137 16.8238 14.6044C18.6941 14.5997 18.9519 14.5856 19.055 14.52C19.2238 14.4122 19.2566 14.2669 19.1488 14.1169C19.0035 13.92 18.755 13.8262 18.2535 13.7794C17.841 13.7465 15.4457 13.7372 14.7519 13.77Z" fill="black" />
    </svg>

  );
};
